// Saved Queries API
import { apiClient } from './client'

export interface SavedQuery {
  id: string
  name: string
  description?: string
  query_text: string
  qa_mode: 'text2cypher' | 'vector'
  entity_a_id?: string
  entity_a_name?: string
  entity_b_id?: string
  entity_b_name?: string
  created_at: string
  last_run_at?: string
}

export interface CreateSavedQueryRequest {
  name: string
  description?: string
  query_text: string
  qa_mode: 'text2cypher' | 'vector'
  entity_a_id?: string
  entity_a_name?: string
  entity_b_id?: string
  entity_b_name?: string
}

export const savedQueriesApi = {
  list: (caseId: string) => apiClient.get<SavedQuery[]>(`/cases/${caseId}/saved-queries`),

  create: (caseId: string, request: CreateSavedQueryRequest) =>
    apiClient.post<SavedQuery>(`/cases/${caseId}/saved-queries`, request),

  delete: (caseId: string, queryId: string) =>
    apiClient.delete<void>(`/cases/${caseId}/saved-queries/${queryId}`),

  markAsRun: (caseId: string, queryId: string) =>
    apiClient.post<void>(`/cases/${caseId}/saved-queries/${queryId}/run`),
}
